import { render, staticRenderFns } from "./DeclarationAtCev.vue?vue&type=template&id=b3e83d5c&scoped=true"
import script from "./DeclarationAtCev.vue?vue&type=script&lang=js"
export * from "./DeclarationAtCev.vue?vue&type=script&lang=js"
import style0 from "./DeclarationAtCev.vue?vue&type=style&index=0&id=b3e83d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e83d5c",
  null
  
)

export default component.exports